import React from 'react';
import { Input } from 'antd';
import { btnTypes } from '../../../../../../../../components/btn';
import ActionBtn from '../ActionBtn';
import styles from './index.module.scss';

const Content = ({ onOk, onReset, onChange, inputRef, placeholder, value }) => {
  return (
    <div className={styles.content}>
      <Input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onPressEnter={onOk}
      />
      <div className={styles.actions}>
        <ActionBtn type={btnTypes.primary} onClick={onOk} icon="search">
          Найти
        </ActionBtn>
        <ActionBtn type={btnTypes.secondary} onClick={onReset}>
          Сбросить
        </ActionBtn>
      </div>
    </div>
  );
};

export default Content;
